<template>
  <div>
    <Dialog
      :header="$t('operacion.impagos.tituloNuevo')"
      :modal="true"
      :visible.sync="displayModal"
      :contentStyle="{ overflow: 'visible' }"
      @hide="closeDialog"
    >
      <Errors v-show="this.errors.length > 0" :errors="this.errors" />

      <div class="p-grid p-fluid p-formgrid">
        <div class="p-col-12 p-md-6 p-field">
          <label for="fechaPago"
            ><b>{{ $t("operacion.impagos.fechaVencimiento") }}</b></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-calendar"></i>
            </span>
            <Calendar
              id="icon"
              :class="`input ${validation.fechaVencimiento === false && 'p-invalid'}`"
              v-model="impago.fechaVencimiento"
              dateFormat="dd/mm/yy"
              :showIcon="true"
              :showTime="false"
              :locale="getLocale"
            />
          </div>
        </div>

        <div class="p-col-12 p-md-6 p-field">
          <label for="importe"
            ><b>{{ $t("operacion.impagos.importe") }}</b></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-money-bill"></i>
            </span>
            <InputNumber
              :class="`input ${validation.importe === false && 'p-invalid'}`"
              id="importe"
              v-model="impago.importe"
              mode="decimal"
              :min="0.01"
              :maxFractionDigits="2"
              :placeholder="$t('operacion.pagosCuenta.placeHolders.importe')"
            />
          </div>
        </div>

        <div class="p-col-12 p-md-6 p-field">
          <label for="referenciaCliente"
            ><b>{{ $t("operacion.impagos.numeroReferencia") }}</b></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-id-card"></i>
            </span>
            <InputText
              :class="`input ${validation.referenciaCliente === false && 'p-invalid'}`"
              id="referenciaCliente"
              type="text"
              v-model="impago.referenciaCliente"
              :placeholder="
                $t('operacion.pagosCuenta.placeHolders.referenciaCliente')
              "
            />
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          @click.prevent="saveImpago()"
          :label="$t('common.buttons.save')"
          class=""
          icon="pi pi-save"
          iconPos="left"
        />
        <Button
          @click.prevent="closeDialog()"
          :label="$t('common.buttons.cancel')"
          class="p-button-secondary"
          icon="pi pi-times"
          iconPos="left"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Errors from "@/components/utilidades/Errors.vue";

import { ADD_IMPAGO } from "@/graphQLQueries/ImpagoQueries";

export default {
  name: "AltaImpago",
  props: ["operacionUuid", "clienteIdLegal", "displayModal","tipoSociedad","limiteOperacionPPFF","limiteOperacionPPJJ"],
  components: {
    Errors: Errors,
  },
  data() {
    return {
      impago: {},
      errors: [],
      validation: {
        importe: true,
        fechaVencimiento: true,
        referenciaCliente: true,
      },
    };
  },
  methods: {
    saveImpago() {
      this.validateImpago()
      if (!this.errors.length){
        this.$apollo
        .mutate({
          mutation: ADD_IMPAGO,
          variables: {
            importe: this.impago.importe,
            fechaVencimiento: new Date(this.impago.fechaVencimiento).getTime(),
            referenciaCliente: this.impago.referenciaCliente,
            operacionUuid: this.operacionUuid,
            uuidUsuario: this.$store.state.profile.uuid,
          },
        })
        .then(() => {
          this.closeDialog();
        })
        .catch((exception) => {
          this.errors = [];
          exception.graphQLErrors.forEach((error) => {
            this.errors.push(this.getMessageError(error.message));
          });
        });
      }
    },
    getMessageError(error) {
      let errores = ["1033"];
      if (errores.includes(error)) {
        return this.$i18n.t("operacion.impagos.errores." + error.message);
      } else if(error.includes("No error codes")) {
        return this.$i18n.t("operacion.impagos.errores.9999994");
      } else {
        return this.$i18n.t("operacion.impagos.errores.error", {
          error: error,
        });
      }
    },
    closeDialog() {
      this.$emit("close-dialog", null);
      this.errors = [];
    },
    resetInputs() {
      this.impago = {};
    },
    validateImpago() {
      this.errors = [];
      this.validation = {
        importe: true,
        fechaVencimiento: true,
        referenciaCliente: true,
      };
      if (!this.impago.referenciaCliente){
        this.errors.push(
          this.$t("operacion.impagos.errores.9999999"));
        this.validation.referenciaCliente = false
      }
      if (!this.impago.fechaVencimiento){
        this.errors.push(
          this.$t("operacion.impagos.errores.9999995"));
        this.validation.fechaVencimiento = false
      }
      if (!this.impago.importe){
        this.errors.push(
          this.$t("operacion.impagos.errores.9999996"));
        this.validation.importe = false
      }
    }
  },
  computed: {
    getLocale() {
      return this.$i18n.t("calendar");
    },
  },
  watch: {
    displayModal(newValue) {
      if (newValue) this.resetInputs();
    },
  },
};
</script>

<style scoped>
.marginBottom {
  margin-bottom: 0.3cm;
  margin-top: 1cm;
}
</style>